module.exports = __webpack_public_path__ + "static/media/payment-card-logo.bf15a390.svg";